import { render, staticRenderFns } from "./ExpenseTableBody.vue?vue&type=template&id=f842e5f4&"
import script from "./ExpenseTableBody.vue?vue&type=script&lang=js&"
export * from "./ExpenseTableBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports